/**
 * Created by frank.law on 12/22/17.
 */
import React from 'react';
import '../../../css/login.css';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

class QRCodeContainer extends React.Component {
    render() {

        const {value} = this.props;

        return (
            <div className="code-container">
                <QRCode value={value} />
            </div>
        );
    }
}

QRCodeContainer.propTypes = {
    value: PropTypes.string
};

export default QRCodeContainer;
